"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyLinkAndWelcomeMessage = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Shows CopyLinkInputButton and welcome message
 * @param {CopyLinkAndWelcomeMessageProps} props
 * @returns {JSX.Element}
 */
const CopyLinkAndWelcomeMessage = ({
  link,
  welcomeMessage
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    gamificationActivityType
  } = (0, _contexts.useFeedbackBenefitDialog)();
  const {
    createGamificationActivity
  } = (0, _presentationHttp.useCreateGamificationActivity)({
    activityType: gamificationActivityType
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.COPY_LINK_AND_WELCOME_MESSAGE),
    children: [link ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CopyLinkInputButton, {
      buttonText: translations.copy,
      copiedText: translations.linkCopied,
      link: link
      // The activity is created only for logged-in users, as per the createGamificationActivity implementation
      ,
      onCopy: createGamificationActivity
    }) : null, welcomeMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      color: "textPrimary",
      "data-testid": getTestId(_constants.WELCOME_MESSAGE),
      children: welcomeMessage
    }) : null]
  });
};
exports.CopyLinkAndWelcomeMessage = CopyLinkAndWelcomeMessage;
